(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6438],{

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 45996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/Media.js
var Media = __webpack_require__(9505);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./containers/Header/index.js + 15 modules
var Header = __webpack_require__(30874);
// EXTERNAL MODULE: ./containers/Main/Main.jsx
var Main = __webpack_require__(26217);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/icons/CarouselChevronTop.js

var _excluded = ["title"];




var SvgCarouselChevronTop = function SvgCarouselChevronTop(_ref) {
  var title = _ref.title,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60"
  }, props, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        id: "carousel-chevron-top_svg__b",
        cx: 20,
        cy: 20,
        r: 20
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "carousel-chevron-top_svg__a",
        width: "187.5%",
        height: "187.5%",
        x: "-43.8%",
        y: "-31.2%",
        filterUnits: "objectBoundingBox",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: 5,
          "in": "SourceAlpha",
          result: "shadowOffsetOuter1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          "in": "shadowOffsetOuter1",
          result: "shadowBlurOuter1",
          stdDeviation: 5
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          "in": "shadowBlurOuter1",
          in2: "SourceAlpha",
          operator: "out",
          result: "shadowBlurOuter1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          "in": "shadowBlurOuter1",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        opacity: 0.8,
        transform: "translate(10 5)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("use", {
          fill: "#000",
          filter: "url(#carousel-chevron-top_svg__a)",
          xlinkHref: "#carousel-chevron-top_svg__b"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: 20,
          cy: 20,
          r: 19.5,
          fill: "#FFF",
          stroke: "#EAEAEA",
          strokeLinejoin: "square"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M35.333 24L30 18.667 24.667 24m10.666 6L30 24.667 24.667 30",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      })]
    })]
  }));
};

/* harmony default export */ var CarouselChevronTop = (SvgCarouselChevronTop);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./components/ScrollToTop/ScrollToTop.jsx







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var MINIMUM_HEIGHT_TO_DISPLAY_SCROLL_ICON = 100;
var fadeIn = (0,styled_components_browser_esm.keyframes)(["0%{opacity:0;}50%{opacity:0.5;}100%{opacity:1;}"]);
var StyledTop = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-nzu4nl-0"
})(["display:", ";position:fixed;right:0.5rem;bottom:1.5rem;z-index:1;cursor:pointer;> svg{width:3.75rem;height:3.75rem;color:#1557bf;}animation:", " 0.35s ease-in;"], function (props) {
  return props.displayScrollTop ? 'block' : 'none';
}, fadeIn);

var ScrollToTop = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(ScrollToTop, _Component);

  var _super = _createSuper(ScrollToTop);

  function ScrollToTop(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ScrollToTop);

    _this = _super.call(this, props);
    _this.state = {};
    _this.handleScrollTopDisplay = throttle_default()(_this.handleScrollTopDisplay.bind((0,assertThisInitialized/* default */.Z)(_this)), 200);
    _this.handleScrollToTop = _this.handleScrollToTop.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(ScrollToTop, [{
    key: "handleScrollTopDisplay",
    value: function handleScrollTopDisplay() {
      var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

      if (scrollTop > MINIMUM_HEIGHT_TO_DISPLAY_SCROLL_ICON !== this.state.displayScrollTop) {
        this.setState({
          displayScrollTop: scrollTop > MINIMUM_HEIGHT_TO_DISPLAY_SCROLL_ICON
        });
      }
    }
  }, {
    key: "handleScrollToTop",
    value: function handleScrollToTop() {
      __webpack_require__.e(/* import() */ 6261).then(__webpack_require__.bind(__webpack_require__, 66261)).then(function (scroll) {
        scroll.animateScroll.scrollToTop({
          duration: 500,
          smooth: true,
          ignoreCancelEvents: false
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleScrollTopDisplay();
      window.addEventListener('scroll', this.handleScrollTopDisplay, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScrollTopDisplay);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTop, {
        onClick: this.handleScrollToTop,
        displayScrollTop: this.state.displayScrollTop,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselChevronTop, {})
      });
    }
  }]);

  return ScrollToTop;
}(react.Component);

/* harmony default export */ var ScrollToTop_ScrollToTop = (ScrollToTop);
// EXTERNAL MODULE: ./components/GlobalContext.jsx
var GlobalContext = __webpack_require__(87279);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(57756);
;// CONCATENATED MODULE: ./components/Layout/Layout.jsx








function Layout_createSuper(Derived) { var hasNativeReflectConstruct = Layout_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Layout_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }













var DeliverySlotHelloBar = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 432).then(__webpack_require__.bind(__webpack_require__, 432));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(432)];
    }
  }
});
var Footer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6986).then(__webpack_require__.bind(__webpack_require__, 26986));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26986)];
    }
  }
});
var Container = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-1e9xyj2-0"
})(["display:flex;flex:1;flex-direction:column;"]);
var FooterWrapper = styled_components_browser_esm["default"].footer.withConfig({
  componentId: "sc-1e9xyj2-1"
})(["flex-shrink:0;", "{display:none;}", "{display:none;}"], Media/* SCREEN_SIZE.Only.Mobile */.yJ.Only.Mobile, Media/* SCREEN_SIZE.Only.MobileL */.yJ.Only.MobileL);
var MainWrapper = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-1e9xyj2-2"
})(["margin:0.8125rem 0 0;", "{margin-top:1rem;padding-left:1.5rem;padding-right:1.5rem;min-height:calc(100vh - 6.25rem - 28.5625rem);}", "{min-height:calc(100vh - 12.625rem - 19.0781rem);}", "{max-width:100rem;margin-left:auto;margin-right:auto;}", ""], Media/* SCREEN_SIZE.From.Tablet */.yJ.From.Tablet, Media/* SCREEN_SIZE.From.Desktop */.yJ.From.Desktop, Media/* SCREEN_SIZE.From.UhdL */.yJ.From.UhdL, function (_ref) {
  var noWrapper = _ref.noWrapper;
  return noWrapper === 'noGap' && 'padding: 0 !important; margin: 0 auto !important;';
});
var Overlay = styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-1e9xyj2-3"
})(["", "{position:fixed;top:", ";background-color:rgba(51,51,51,0.8);z-index:100;width:100vw;height:100vh;transition:opacity 0.2s 0.2s,visibility 0.2s 0.2s;opacity:", ";visibility:", ";}"], Media/* SCREEN_SIZE.From.Tablet */.yJ.From.Tablet, function (_ref2) {
  var hasBackdrop = _ref2.hasBackdrop;
  return hasBackdrop ? window && window.getComputedStyle(document.getElementsByTagName('header')[0]).height || '162px' : '';
}, function (_ref3) {
  var hasBackdrop = _ref3.hasBackdrop;
  return hasBackdrop ? '1' : '0';
}, function (_ref4) {
  var hasBackdrop = _ref4.hasBackdrop;
  return hasBackdrop ? 'visible' : 'hidden';
});

var Layout = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Layout, _Component);

  var _super = Layout_createSuper(Layout);

  function Layout(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Layout);

    _this = _super.call(this, props);
    _this.state = {
      backdrop: []
    };
    _this.handleBackdrop = _this.handleBackdrop.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(Layout, [{
    key: "handleBackdrop",
    value: function handleBackdrop(value) {
      var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

      //possibly having many backdrops at the same time
      if (value) {
        if (!this.state.backdrop.some(function (x) {
          return x === component;
        })) {
          this.setState({
            backdrop: [].concat((0,toConsumableArray["default"])(this.state.backdrop), [component])
          });
        }

        return;
      }

      this.setState(function (prevState) {
        return {
          backdrop: prevState.backdrop.filter(function (x) {
            return x !== component;
          })
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _prevState$backdrop;

      if (((_prevState$backdrop = prevState.backdrop) === null || _prevState$backdrop === void 0 ? void 0 : _prevState$backdrop.length) !== this.state.backdrop.length) {
        var shouldDisableScroll = !!this.state.backdrop.length;
        (0,utils/* disablePageScroll */.XD)(shouldDisableScroll);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          organizationData = _this$props.organizationData,
          noWrapper = _this$props.noWrapper,
          noFooter = _this$props.noFooter,
          categoryList = _this$props.categoryList,
          router = _this$props.router;
      var backdrop = this.state.backdrop;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [backdrop && backdrop.length > 0 && (0,utils/* disablePageScroll */.XD)(true), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
          className: className,
          "data-testid": "layout",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
              organizationData: organizationData,
              categoryList: categoryList,
              onHandleBackdrop: this.handleBackdrop,
              hasNewVouchers: this.props.hasNewVouchers,
              hasPaymentAlert: this.props.hasPaymentAlert
            }), (router === null || router === void 0 ? void 0 : router.pathname) === '/' && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliverySlotHelloBar, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Overlay, {
              hasBackdrop: backdrop && backdrop.length > 0
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(MainWrapper, {
              noWrapper: noWrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Main/* default */.Z, {
                noWrapper: noWrapper,
                children: children
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterWrapper, {
            children: noFooter ? '' : /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {
              organizationData: organizationData
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollToTop_ScrollToTop, {})]
        })]
      });
    }
  }]);

  return Layout;
}(react.Component);

Layout.defaultProps = {
  organizationData: {}
};

var LayoutWrapper = function LayoutWrapper(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalContext/* default.Consumer */.Z.Consumer, {
    children: function children(_ref5) {
      var experiments = _ref5.experiments,
          remoteConfig = _ref5.remoteConfig;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout, Object.assign({}, props, {
        experiments: experiments,
        remoteConfig: remoteConfig
      }));
    }
  });
};

/* harmony default export */ var Layout_Layout = ((0,router.withRouter)(LayoutWrapper));

/***/ }),

/***/ 26217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _lib_Media__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9505);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var MainContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].main.withConfig({
  componentId: "sc-mhgwiq-0"
})(["margin:0 auto;min-height:20vh;padding:0 1rem;", "{padding:0 0 2rem 0;}", "{padding-left:0;padding-right:0;}"], _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Tablet */ .yJ.From.Tablet, _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Desktop */ .yJ.From.Desktop);
var MainTablet = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(MainContainer).withConfig({
  componentId: "sc-mhgwiq-1"
})(["", "{padding:0.5rem 0;margin:0rem;}"], _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Tablet */ .yJ.From.Tablet);
var MainDesktop = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(MainContainer).withConfig({
  componentId: "sc-mhgwiq-2"
})(["", "{padding:0.5rem 0;margin:0rem;}"], _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Desktop */ .yJ.From.Desktop);
var MainHd = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(MainContainer).withConfig({
  componentId: "sc-mhgwiq-3"
})(["", "{padding:0.5rem 0;margin:0rem;}"], _lib_Media__WEBPACK_IMPORTED_MODULE_1__/* .SCREEN_SIZE.From.Hd */ .yJ.From.Hd);
var NoGapContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(MainContainer).withConfig({
  componentId: "sc-mhgwiq-4"
})(["padding:0;margin:0;"]);

var Main = function Main(_ref) {
  var children = _ref.children,
      _ref$noWrapper = _ref.noWrapper,
      noWrapper = _ref$noWrapper === void 0 ? 'default' : _ref$noWrapper;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [noWrapper === 'fromMobile' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("main", {
      children: children
    }), noWrapper === 'fromTablet' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(MainTablet, {
      children: children
    }), noWrapper === 'fromDesktop' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(MainDesktop, {
      children: children
    }), noWrapper === 'fromHd' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(MainHd, {
      children: children
    }), noWrapper === 'noGap' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(NoGapContainer, {
      children: children
    }), noWrapper === 'default' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(MainContainer, {
      children: children
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Main);

/***/ }),

/***/ 49546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59499);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92777);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(82262);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10748);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81531);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45996);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_EventTrackingProvider_EventTrackingProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87661);
/* harmony import */ var _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31035);
/* harmony import */ var _utils_configService__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66738);
/* harmony import */ var _utils_configService__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_utils_configService__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43354);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_utils_constants__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19521);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }













var GlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__.createGlobalStyle)([".publitas-container{position:relative;width:100%;height:0;padding-top:130%;}@media (min-width:767px){.publitas-container{padding-top:66%;}}.publitas-container iframe{position:absolute;top:0;left:0;bottom:0;right:0;width:100%;height:100%;}"]);

var WeeklyPromos = /*#__PURE__*/function (_React$Component) {
  (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(WeeklyPromos, _React$Component);

  var _super = _createSuper(WeeklyPromos);

  function WeeklyPromos(props) {
    var _this;

    (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(this, WeeklyPromos);

    _this = _super.call(this, props);
    _this.getContent = _this.getContent.bind((0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_this));
    return _this;
  }

  (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(WeeklyPromos, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props, _this$props$router, _this$props$track;

      var publitasSplit = (0,_utils_configService__WEBPACK_IMPORTED_MODULE_8__.getExpConfig)(_utils_constants__WEBPACK_IMPORTED_MODULE_9__.SPLIT_FEATURES.PUBLITAS);
      var isEnablePublitasSplit = (publitasSplit === null || publitasSplit === void 0 ? void 0 : publitasSplit.treatment) === 'on';
      var that = this;
      /* istanbul ignore next */

      if (isEnablePublitasSplit) {
        window.addEventListener('message', function (event) {
          if (event.origin !== 'https://view.publitas.com') {
            return;
          }

          var payload = JSON.parse(event.data);

          if (payload && payload.event) {
            that.props.track(payload);
          }
        }, false);
      }

      var _ref = ((_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$router = _this$props.router) === null || _this$props$router === void 0 ? void 0 : _this$props$router.query) || {},
          slug = _ref.slug,
          skuid = _ref.skuid;

      this.props.track((_this$props$track = {}, (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this$props$track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .GTM_ENV_VAR.USER_ID */ .Zr.USER_ID, skuid), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this$props$track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .GTM_ENV_VAR.PAGE_TYPE */ .Zr.PAGE_TYPE, 'promotion'), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this$props$track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .GTM_ENV_VAR.SCREEN_NAME */ .Zr.SCREEN_NAME, "promotions - ".concat(slug)), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this$props$track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .GTM_ENV_VAR.EVENT_CAT */ .Zr.EVENT_CAT, 'internal promotions'), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this$props$track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .GTM_ENV_VAR.EVENT_ACTION */ .Zr.EVENT_ACTION, 'landed'), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this$props$track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .GTM_ENV_VAR.EVENT_LABEL */ .Zr.EVENT_LABEL, 'swa publitas'), _this$props$track));
    }
  }, {
    key: "getContent",
    value: function getContent(skuid, slug) {
      if (true) {
        var promo1Url = "https://view.publitas.com/fairpricegroup/pdbn-fresh-vpjzdakrz646/?publitas_embed=maximized&skuid=".concat(skuid);
        var promo2Url = "https://view.publitas.com/fairpricegroup/pdbn-fresh-7eyjjw7rjgo8/?publitas_embed=maximized&skuid=".concat(skuid);
        var promo3Url = "https://view.publitas.com/fairpricegroup/pdbn-fresh-7eyjjw7rjgo8-apdgq3oogbj9/?publitas_embed=maximized&skuid=".concat(skuid);
        var promo4Url = "https://view.publitas.com/fairpricegroup/pdbn-fresh-7eyjjw7rjgo8-by3kb6ejg_gk/?publitas_embed=maximized&skuid=".concat(skuid);
        var promo5Url = "https://view.publitas.com/fairpricegroup/pdbn-fresh/?publitas_embed=maximized&skuid=".concat(skuid);

        switch (slug) {
          case 'weekly-promo-1':
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              "data-testid": "weekly-promo-1",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: "publitas-container",
                dangerouslySetInnerHTML: {
                  __html: "\n               <iframe src=".concat(promo1Url, " style=\"display: block; box-sizing: border-box;\" frameborder=\"0\" allowfullscreen=\"allowfullscreen\"></iframe>")
                }
              })
            });

          case 'weekly-promo-2':
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              "data-testid": "weekly-promo-2",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: "publitas-container",
                dangerouslySetInnerHTML: {
                  __html: "\n               <iframe src=".concat(promo2Url, " style=\"display: block; box-sizing: border-box;\" frameborder=\"0\" allowfullscreen=\"allowfullscreen\"></iframe>")
                }
              })
            });

          case 'weekly-promo-3':
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              "data-testid": "weekly-promo-3",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: "publitas-container",
                dangerouslySetInnerHTML: {
                  __html: "\n               <iframe src=".concat(promo3Url, " style=\"display: block; box-sizing: border-box;\" frameborder=\"0\" allowfullscreen=\"allowfullscreen\"></iframe>")
                }
              })
            });

          case 'weekly-promo-4':
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              "data-testid": "weekly-promo-4",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: "publitas-container",
                dangerouslySetInnerHTML: {
                  __html: "\n               <iframe src=".concat(promo4Url, " style=\"display: block; box-sizing: border-box;\" frameborder=\"0\" allowfullscreen=\"allowfullscreen\"></iframe>")
                }
              })
            });

          case 'weekly-promo-5':
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              "data-testid": "weekly-promo-5",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: "publitas-container",
                dangerouslySetInnerHTML: {
                  __html: "\n               <iframe src=".concat(promo5Url, " style=\"display: block; box-sizing: border-box;\" frameborder=\"0\" allowfullscreen=\"allowfullscreen\"></iframe>")
                }
              })
            });

          default:
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              "data-testid": "no-promo"
            });
        }
      } else {}
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          organizationData = _this$props2.organizationData,
          categoryList = _this$props2.categoryList,
          router = _this$props2.router;

      var _ref2 = (router === null || router === void 0 ? void 0 : router.query) || {},
          skuid = _ref2.skuid,
          slug = _ref2.slug;

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("title", {
            children: [slug, " | NTUC FairPrice"]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          organizationData: organizationData,
          categoryList: categoryList,
          noWrapper: "noGap",
          children: [this.getContent(skuid, slug), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(GlobalStyle, {})]
        })]
      });
    }
  }]);

  return WeeklyPromos;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);

var WeeklyPromosPageWrapper = function WeeklyPromosPageWrapper(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_EventTrackingProvider_EventTrackingProvider__WEBPACK_IMPORTED_MODULE_6__/* .EventTrackingConsumer */ .fI, {
    children: function children(_ref3) {
      var track = _ref3.track;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(WeeklyPromos, Object.assign({}, props, {
        track: track
      }));
    }
  });
};

/* harmony default export */ __webpack_exports__["default"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_5__.withRouter)(WeeklyPromosPageWrapper));

/***/ }),

/***/ 84610:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swa/weekly-promos",
      function () {
        return __webpack_require__(49546);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6012,4133,874,8893,9774,2888,179], function() { return __webpack_exec__(84610); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);